module.exports = __webpack_public_path__ + "73e9dd2104cb22658efb584e53fe4af2.pdf";